module.exports = __webpack_public_path__ + "img/blue-uv-capture-black.3b2cfca4.svg";